// extracted by mini-css-extract-plugin
export default {"container":"MenuProvider_container__3Oeau"};